let state = {
    request_XML: "",
    metadata_SP_URL: "",
    metadata_SP_XML: "",
    response_test_done: {},
    response_test_success: {},
    response_test_note: {}
}

export default state;



// WEBPACK FOOTER //
// ./src/redux/main/initialState.js